import { camelcase, startcase } from '.';

/**
 * Converts a string to pascal case
 *
 * @param s the string to be converted
 * @returns the converted string
 */
export function pascalCase(s: string): string {
  return startcase(camelcase(s)).replace(/\s/g, '');
}
